import React from 'react'
import MediaQuery from 'react-responsive'

import QUERIES from 'styles/config/queries'

/*
 * Usage:
 * <Responsive.desktop>
 *   <div>Visible only on desktop 💻</div>
 * </Responsive.desktop>
 * <Responsive.mobile>
 *   <div>Visible only on mobile 📱</div>
 * </Responsive.mobile>
 * */
const Responsive = Object.keys(QUERIES).reduce((acc, query) => {
  acc[query] = props => (
    <MediaQuery {...props} query={QUERIES[query]} />
  )
  return acc
}, {})

export default Responsive



// WEBPACK FOOTER //
// ./src/components/Responsive/index.js